/**
 * @group Data
 * @summary User management actions
 * 
 * @remarks
 * This constant contains action names used in user management operations,
 * specifically for role assignment and removal.
 * 
 * @example
 * ```typescript
 * import { USER_ACTIONS } from '@shared/constants';
 * 
 * switch (action) {
 *   case USER_ACTIONS.ADD_ROLE:
 *     return await addRoleToUser(userId, roleId);
 *   case USER_ACTIONS.REMOVE_ROLE:
 *     return await removeRoleFromUser(userId, roleId);
 * }
 * ```
 */
export const USER_ACTIONS = {
  ADD_ROLE: 'addRole',
  REMOVE_ROLE: 'removeRole'
} as const; 